// @ts-nocheck
import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { DollarSign } from 'lucide-react';
import VendorPayoutsTab from '@/components/admin/mikes-dash/VendorPayoutsTab';
import ScoutPayoutsTab from '@/components/admin/mikes-dash/ScoutPayoutsTab';
import AffiliatePayoutsTab from '@/components/admin/mikes-dash/AffiliatePayoutsTab';
import SubscriptionsTab from '@/components/admin/mikes-dash/SubscriptionsTab';
import ReportsTab from '@/components/admin/mikes-dash/ReportsTab';
import AuditTrailTab from '@/components/admin/mikes-dash/AuditTrailTab';
import MentionsTab from '@/components/admin/mikes-dash/MentionsTab';
import PayVendorsTab from '@/components/admin/mikes-dash/PayVendorsTab';

const MikesDashboard: React.FC = () => {
  const [activeTab, setActiveTab] = useState('vendors');

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3">
        <DollarSign className="h-8 w-8 text-secondary" />
        <div>
          <h1 className="text-3xl font-heading font-bold text-foreground">Mike's Financial Dashboard</h1>
          <p className="text-muted-foreground">Comprehensive payout and financial management center</p>
        </div>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
        <TabsList className="grid w-full grid-cols-5 lg:grid-cols-9">
          <TabsTrigger value="vendors">Vendors</TabsTrigger>
          <TabsTrigger value="pay-vendors">Pay Vendors</TabsTrigger>
          <TabsTrigger value="scouts">Scouts</TabsTrigger>
          <TabsTrigger value="affiliates">Affiliates</TabsTrigger>
          <TabsTrigger value="subscriptions">Subscriptions</TabsTrigger>
          <TabsTrigger value="mentions">Mentions</TabsTrigger>
          <TabsTrigger value="reports">Reports</TabsTrigger>
          <TabsTrigger value="audit">Audit Trail</TabsTrigger>
        </TabsList>

        <TabsContent value="vendors" className="space-y-6">
          <VendorPayoutsTab />
        </TabsContent>

        <TabsContent value="pay-vendors" className="space-y-6">
          <PayVendorsTab />
        </TabsContent>

        <TabsContent value="scouts" className="space-y-6">
          <ScoutPayoutsTab />
        </TabsContent>

        <TabsContent value="affiliates" className="space-y-6">
          <AffiliatePayoutsTab />
        </TabsContent>

        <TabsContent value="subscriptions" className="space-y-6">
          <SubscriptionsTab />
        </TabsContent>

        <TabsContent value="mentions" className="space-y-6">
          <MentionsTab />
        </TabsContent>

        <TabsContent value="reports" className="space-y-6">
          <ReportsTab />
        </TabsContent>

        <TabsContent value="audit" className="space-y-6">
          <AuditTrailTab />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default MikesDashboard;
